import { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '../../../component/common/loading/Loading.jsx';
import MergedTableHeader from '../../../component/common/dataGrid/MergedTableHeader.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';

import '../../../css/data-grid.css';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';

const FidelityCommonPopup = () => {

    const sendData = JSON.parse(localStorage.getItem('fidelityInput'));

    const allEMOG = decodeURIComponent(decodeURIComponent(sendData.emtInsttNm)) === '전체';
    const commonDataHead1 = ['의무기록번호', '내원일자', '내원시간', '표준환자정보', '표준환자정보', '표준환자정보', '표준환자정보', '표준환자정보', '표준환자정보', '외상환자정보', '외상환자정보', '외상환자정보', '외상환자정보'];
    const commonDataHead2 = ['의무기록번호', '내원일자', '내원시간', '보기', '자료처리상태', '질병여부', '손상기전', '주된 진료를 받은 응급의료센터', '응급진료결과', '보기', '자료처리상태', '환자분류', '손상유형'];
    const dataColumn = ['PTMIIDNO', 'PTMIINDT', 'PTMIINTM', 'VIEW', 'PTMISTAT', 'PTMIDGKD', 'PTMIARCS', 'PTMIMDCD', 'PTMIEMRT', 'VIEW2', 'TRMSSTAT', 'TRMSPTGB', 'TRMSDMTP'];

    if (allEMOG) {
        commonDataHead1.unshift('기관명');
        commonDataHead2.unshift('기관명');
        dataColumn.unshift('INSTT_NM');
    }
    if (sendData.iem_cd) {
        commonDataHead1.push('오류 및 재검토 결과');
        commonDataHead2.push('오류 및 재검토 결과');
        dataColumn.push('C' + sendData.iem_cd);
    }

    const dataHead = [];
    dataHead.push(commonDataHead1);
    dataHead.push(commonDataHead2);

    const apiCall = '/ptmiapi/fidelityCommonStaticDetailListData.do';
    const apiCntCall = '';
    const excelFileName = '충실도_세부항목리스트';
    const [list, setList] = useState([]);

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [totalItems, setTotalItems] = useState(0);

    const popupPropsInfo = {
        checked: ["VIEW", "VIEW2"],
        localStorageName: "operRegAftDttbListData",
        popupAddress: "/nedis/trmsInfo/trms_operRegAftDttbList_popup.do",
        width: '750',
        height: '250'
    }

    const fetchData = async () => {
        try {
            const response = await axios.get(apiCall,
                { params: sendData }
            );
            setList(response.data.fdltTargetInfo);
            setState(prev => ({
                ...prev,
                dataList: response.data.detailList,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setTotalItems(response.data.detailList.length);
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: sendData }
            );
            setTotalItems(response.data);
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const search = () => {
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        fetchData();
    };

    useEffect(() => {
        search();
    }, []);

    const fidelitySendStatic = sendData.targetData !== 'INPUT_CO' && sendData.targetData !== 'TRGET_CO' && sendData.targetData !== 'HYPTRPYUPPT_INPUT_CO' && sendData.targetData !== 'TRGET_UNINPUT_CO';

    return (
        <div className='popup_container bg_tr_bg'>
            <h5>세부내역리스트</h5>
            <div className='data_grid_container'>
                <div className='mb-3'>
                    <hr className={`border-t-2 tr_border_soft`} />
                    <div className='flex'>
                        <table>
                            <colgroup>
                                <col width='10%' />
                                <col width='40%' />
                                <col width='10%' />
                                <col width='40%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='border-l-1 border-b-1 bg_tr_odd'>기관명</th>
                                    <td className={fidelitySendStatic ? '' : 'border-r-0'} colSpan={fidelitySendStatic ? '0' : '3'}>{decodeURIComponent(decodeURIComponent(sendData.emtInsttNm))}</td>
                                    {fidelitySendStatic ?
                                        <>
                                            <th className='border-b-1 bg_tr_odd'>항목명</th>
                                            <td className='border-r-0'>{list.CD_NM}</td>
                                        </>
                                        :
                                        <></>
                                    }
                                </tr>
                            </tbody>
                        </table>
                        {excelFileName === '' ? <></> :
                            <div className='bg-white content-center px-2 border-r-1 border-b-1'>
                                <ExcelDownload
                                    excelHead={dataHead}
                                    excelData={state.dataList}
                                    searched={state.isSearched}
                                    dataCode={dataColumn}
                                    excelFileName={excelFileName}
                                />
                            </div>
                        }
                    </div>
                </div>
                <span className='total_items mb-1'>전체&nbsp;<strong className='tr_color'>{totalItems}</strong>건</span>
                {state.isLoading ? <Loading /> :
                    <>
                        <hr className={`border-t-2 mr-1-1 tr_border_soft`} />
                        <div className={`data_list_table td_wrap ${state.isSearched ? 'grid-animation' : ''}`}>
                            <table>
                                <MergedTableHeader
                                    headers={dataHead}
                                />
                                <tbody>
                                    {state.dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className='data_empty bg_tr_odd'>
                                                    {state.isSearched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                    {state.isSearched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    ) : (
                                        state.dataList.map((item, rowIndex) => {
                                            const gridColor = rowIndex % 2 === 0 ? 'bg_tr_odd' : '';
                                            return (
                                                <tr key={rowIndex} className={gridColor}>
                                                    {dataColumn.map((col, colIndex) => {
                                                        const prefix = col;
                                                        const isClickable = popupPropsInfo.checked.includes(prefix);
                                                        const handleClick = async () => {
                                                            let popup = null;
                                                            const senData = {
                                                                emogcode: state.dataList[rowIndex].PTMIEMCD,
                                                                searchIdno: state.dataList[rowIndex].PTMIIDNO,
                                                                searchIndt: state.dataList[rowIndex].PTMIINDT,
                                                                searchIntm: state.dataList[rowIndex].PTMIINTM,
                                                            }
                                                            localStorage.setItem(prefix === 'VIEW' ? 'ptmiData' : 'trmsData', JSON.stringify(senData));
                                                            popup = window.open(prefix === 'VIEW' ? '/nedis/ptmiInfo/bdjrnaeyeoDetail_popup.do' : state.dataList[rowIndex].PTMIINDT >= 20200101 ? '/nedis/trmsInfo/trms_naeyeok_V3_popup.do' : '/nedis/trmsInfo/trms_naeyeok_V2_popup.do', "환자상세정보", `scrollbars=1, resizable=0, width=850, height=910, top=30, left=30`);
                                                        };

                                                        const cellStyle = (isClickable ? `cursor-pointer tr_bright_color_h ${(prefix === "VIEW" || prefix === "VIEW2") ? 'h_icon_box' : 'underline'}` : '');

                                                        const isHospitalColumn = (prefix === 'INSTT_NM');

                                                        const fixedStyle = isHospitalColumn ? { minWidth: '12.5rem' } : {};

                                                        return (
                                                            <td
                                                                key={colIndex}
                                                                onClick={isClickable ? handleClick : undefined}
                                                                className={`${cellStyle}`}
                                                                style={fixedStyle}
                                                            >
                                                                {isClickable && (prefix === "VIEW" || prefix === "VIEW2") ?
                                                                    <div className='detail_icon'>
                                                                        <span className='icon'><Theme.Search16 className='co_black' /></span>
                                                                        <span className='hover_icon'><Theme.Search16 className='tr_bright' /></span>
                                                                    </div>
                                                                    : item[col]}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                    </>
                }
            </div>
            {sendData.iem_cd &&
                <table>
                    <colgroup>
                        <col width='15%' />
                        <col width='85%' />
                    </colgroup>
                    <tbody>
                        <tr className='border'>
                            <th className='bg_tr_odd border-r-1'>진단 내용</th>
                            <td>
                                <textarea className='w-full p-2' rows={4} value={list.DC_CN}></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            }
        </div>
    );
};

export default FidelityCommonPopup;